'use client';

import { Button, Typography } from '@mui/material';
import { useEffect } from 'react';

import { ERROR_HANDLING_LABELS } from '~/definitions/labels';
import { NextErrorProps } from '~/types/next-error-props';

import styles from './error-handled.module.scss';

export const ErrorHandled = (props: NextErrorProps) => {
  const { error, reset } = props;

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error(error);
    // eslint-disable-next-line no-console
    console.dir(error);
  }, [error]);

  return (
    <div className={styles.ErrorHandled}>
      <Typography variant="h4">{ERROR_HANDLING_LABELS.SOMETHING_WENT_WRONG}!</Typography>
      <Typography variant="h3">{error?.message ?? ERROR_HANDLING_LABELS.MESSAGE_GENERAL}</Typography>
      <Typography>
        {ERROR_HANDLING_LABELS.PLEASE_REPORT}
        {error.digest ? ` ${ERROR_HANDLING_LABELS.ERROR_REFERENCE}: ${error.digest}` : null}
      </Typography>
      <div className={styles.buttonRow}>
        <Button onClick={() => reset()}>{ERROR_HANDLING_LABELS.TRY_AGAIN}</Button>
        <Button
          variant="contained"
          // eslint-disable-next-line no-return-assign
          onClick={() => (location.href = '/')}
        >
          {ERROR_HANDLING_LABELS.GO_HOME}
        </Button>
      </div>
    </div>
  );
};
